import { getDomain } from "../help/url";
import { URLS } from "fire-wind-water";

const d = window as any;
const skconf = d.skConfig || {};

export const config: { [label: string]: string | number } = {
  apiUrl: skconf.apiUrl || "//api.smarket.net.cn",
  apiCacheUrl: skconf.apiCacheUrl || "//static.smarket.net.cn/",
  sbaseUrl: skconf.sbaseUrl || "//s2-content.smarket.net.cn/",
  shortUrl: skconf.shortUrl || "//uao.so/",
  matomoUrl: skconf.matomoUrl || "//s2-matomo.smarket.net.cn/",
  weChatOauthUrl: skconf.weChatOauthUrl || "//f.smarket.net.cn/wxoauthb/public/wx_interface/auth",
  usercenterUrl: skconf.usercenterUrl || "//file.smarket.net.cn/spersonalcenter/",
  webinarPosterQrCodeUrl:
    skconf.webinarPosterQrCodeUrl || "//s2-wxoauthb.smarket.net.cn/wbr/poster/",
  webinarPosterUrl: skconf.webinarPosterUrl || "//file.smarket.net.cn/webinarposter/index.html",
  webinarbInteractUrl: skconf.webinarbInteractUrl || "//s2-webinarbinteract.smarket.net.cn/",
  cdn: skconf.cdn || "//s2-cdn.smarket.net.cn",
  domain: skconf.domain || getDomain() || "smarket.net.cn",
  tenantId: skconf.tenantId || URLS.getURL("tenantId"),
};
